import React, { useState } from 'react';
import {
  SegmentsContainer,
  HeaderRow,
  SegmentsLabel,
  ExpandIcon,
  StyledTable,
  TabButton,
} from './styled';
import { useGetViewPredictionsQuery, useGetQualityPredictionsQuery } from 'services/dicomService';
import { PredictionProps } from 'types/predict';

const Prediction: React.FC<PredictionProps> = ({ dicomId, defaultExpanded = true }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const [activeTab, setActiveTab] = useState<'perspectives' | 'qualities'>('perspectives');

  const { data: perspectivesData = [], isFetching: isPersFetching } = useGetViewPredictionsQuery(
    dicomId || 0,
    { skip: !dicomId || !isExpanded }
  );

  const { data: qualitiesData = [], isFetching: isQualFetching } = useGetQualityPredictionsQuery(
    dicomId || 0,
    { skip: !dicomId || !isExpanded }
  );

  const perspectiveColumns = [
    {
      title: 'Pipeline Name',
      key: 'pipeline',
      render: (_: any, record: any) => record.pipeline?.name,
    },
    {
      title: 'Created Date',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (value: string) => (value ? new Date(value).toLocaleString() : ''),
    },
    {
      title: 'Confidence',
      dataIndex: 'confidence',
      key: 'confidence',
      render: (value: number) => value?.toFixed(2),
    },
    {
      title: 'View Name',
      key: 'view',
      render: (_: any, record: any) => record.view_class?.view,
    },
  ];

  const qualitiesColumns = [
    {
      title: 'Pipeline Name',
      key: 'pipeline',
      render: (_: any, record: any) => record.pipeline?.name,
    },
    {
      title: 'Created Date',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (value: string) => (value ? new Date(value).toLocaleString() : ''),
    },
    {
      title: 'Quality',
      key: 'quality',
      render: (_: any, record: any) => record.quality_class?.value,
    },
    {
      title: 'Confidence',
      dataIndex: 'confidence',
      key: 'confidence',
      render: (value: number) => (value !== null ? value.toFixed(2) : ''),
    },
  ];

  return (
    <SegmentsContainer>
      <HeaderRow>
        <SegmentsLabel onClick={() => setIsExpanded(!isExpanded)}>
          <ExpandIcon>{isExpanded ? '▲' : '▼'}</ExpandIcon>
          Predictions
        </SegmentsLabel>
        <TabButton
          active={activeTab === 'perspectives'}
          onClick={() => {
            setActiveTab('perspectives');
            setIsExpanded(true);
          }}
        >
          Perspectives
        </TabButton>
        <TabButton
          active={activeTab === 'qualities'}
          onClick={() => {
            setActiveTab('qualities');
            setIsExpanded(true);
          }}
        >
          Qualities
        </TabButton>
      </HeaderRow>

      {isExpanded && (
        <>
          {activeTab === 'perspectives' ? (
            <StyledTable
              columns={perspectiveColumns}
              dataSource={perspectivesData}
              loading={isPersFetching}
              pagination={false}
              rowKey="uuid"
              scroll={{ x: 'max-content', y: 280 }}
            />
          ) : (
            <StyledTable
              columns={qualitiesColumns}
              dataSource={qualitiesData}
              loading={isQualFetching}
              pagination={false}
              rowKey="uuid"
              scroll={{ x: 'max-content', y: 280 }}
            />
          )}
        </>
      )}
    </SegmentsContainer>
  );
};

export default Prediction;
